export const ProjectsBackgroundVideo = () => {
  return (
    <div>
      <video className="soar-rising-background-video" muted autoPlay loop>
        <source
          src="/images/soarising-background-vid.mp4"
          type="video/mp4"
        ></source>
      </video>
    </div>
  );
};
